// Upload a scan onto a task. Same wire as idea files and NHP: bytes in the
// body, the name in a header. Lands in that clinic's Manager drive.
import { API_BASE } from './config';
import { authToken } from './auth';
import { withViewAs } from './viewAs';

export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;

export interface TaskFile {
  id: number;
  url: string;
  name: string | null;
}

/** `periodStart` — the week/month the file belongs to (082, owner 2026-09-24). */
export async function uploadTaskFile(definitionId: number, file: File, periodStart: string): Promise<TaskFile> {
  if (file.size === 0) throw new Error(`${file.name} is empty`);
  if (file.size > MAX_UPLOAD_BYTES) {
    throw new Error(
      `${file.name} is ${Math.round(file.size / 1048576)} MB — the limit is `
      + `${MAX_UPLOAD_BYTES / 1048576} MB. Put it in Drive and paste the link instead.`,
    );
  }

  const token = authToken.value;
  const res = await fetch(
    `${API_BASE}${withViewAs(`/api/v1/task-definitions/${definitionId}/files`)}`,
    {
      method: 'POST',
      headers: {
        ...(token ? { authorization: `Bearer ${token}` } : {}),
        'content-type': file.type || 'application/octet-stream',
        'x-file-name': encodeURIComponent(file.name),
        'x-period-start': periodStart,
        'idempotency-key': crypto.randomUUID(),
      },
      body: file,
    },
  );

  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((body as { error?: string }).error || `upload failed (HTTP ${res.status})`);
  }
  return (body as { attachment: TaskFile }).attachment;
}
